const jclTokens = {
  brand: {
    accent: "#F59E0B",
    accentSoft: "#FFF7E8",
    primary: "#11183A",
  },
  sidebar: {
    background: "#11183A",
    border: "#20294E",
    text: "#F8FAFC",
    muted: "#8791AD",
    activeBackground: "#1C2850",
    activeText: "#FFFFFF",
    hoverBackground: "#172044",
  },
  surface: {
    canvas: "#F6F7FB",
    card: "#FFFFFF",
    cardMuted: "#FAFBFD",
    border: "#E6E9F0",
    borderStrong: "#D8DDE8",
  },
  text: {
    primary: "#141827",
    secondary: "#687086",
    tertiary: "#9AA1B3",
  },
  status: {
    success: "#1F9D68",
    warning: "#D97706",
    danger: "#DC4C4C",
    info: "#4466D8",
  },
  chart: {
    primary: "#465DCC",
    secondary: "#F59E0B",
    tertiary: "#7C8AC8",
    grid: "#E9ECF3",
  },
  radius: {
    card: 12,
    control: 9,
  },
  shadow: {
    card: "0 1px 2px rgba(16, 24, 40, 0.03)",
    menu: "0 12px 32px rgba(16, 24, 40, 0.12)",
  },
};

export default jclTokens;
